import type { AppointmentsSummaryApi } from "@/Modules/Appointments/Models/Api";

import { get2 } from "./utils/FunctionalTherapyApi";

export async function getAppointments(uuid: string): Promise<AppointmentsSummaryApi> {
  return get2<void, AppointmentsSummaryApi>(`/v1.0/clients/${uuid}/calendar_events`);
}
